// Action to start fetch
export const SWIGGY_ZOMATO_CLAIM_ACTION = 'SWIGGY_ZOMATO_CLAIM_ACTION';

// Action on success
export const SWIGGY_ZOMATO_CLAIM_ACTION_SUCCESS = 'SWIGGY_ZOMATO_CLAIM_ACTION_SUCCESS';

// Action on error
export const SWIGGY_ZOMATO_CLAIM_ERROR_ACTION = 'SWIGGY_ZOMATO_CLAIM_ERROR_ACTION';
